import DashboardModuleBaseArea from '@/modules/dashboard-module/shared/components/base-area/dashboard-module-shared-components-base-area.vue'
import { DashboardViewsAnalyticAreasState, initialDashboardViewsAnalyticAreasState } from '@/modules/dashboard-module/views/analytic-area/dashboard-views-analytic-area.model'
import { Vue, Component } from 'vue-property-decorator'

@Component({
    components: {
        DashboardModuleBaseArea
    }
})
export default class DashboardViewsAnalyticArea extends Vue {
    state: DashboardViewsAnalyticAreasState
    constructor() {
        super()
        this.state = initialDashboardViewsAnalyticAreasState()
    }
}
